var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "section",
    { staticClass: "outline-section" },
    [
      _c(_setup.ColorOptionsClipboardButtons, {
        attrs: {
          title: "Outline",
          "can-copy": !_setup.disabled && _setup.isOutlineEnabled,
          "can-paste": _setup.canPasteColors,
        },
        on: { copy: _setup.onCopyColors, paste: _setup.onPasteColors },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "border-bottom" }),
      _vm._v(" "),
      !_setup.isOutlineEnabled
        ? _c(_setup.CButton, {
            attrs: {
              variant: "secondary",
              text: "Add Outline",
              icon: ["far", "plus"],
              disabled: _setup.disabled,
            },
            on: { click: _setup.addOutline },
          })
        : _c(_setup.ElementLibrarySelector, {
            attrs: {
              disabled: _setup.disabled,
              "element-list": _setup.colors.model.colorsMap,
              "library-id": _setup.colors.model.libraryId,
              "library-type": _setup.COLOR_TYPE,
              "selected-position": _setup.colors.model.option,
              cmyk: _setup.props.cmykMode,
            },
            on: {
              "pick-library": function ($event) {
                return _setup.colors.pickColorLibrary()
              },
              "remove-library": function ($event) {
                return _setup.colors.removeColorLibrary()
              },
              "option-selected": _setup.colors.onColorSelected,
              "remove-map-option": function ($event) {
                return _setup.colors.removeColorOption($event)
              },
              "load-option": (option, value) =>
                _setup.colors.loadColorIntoElement(option, value),
              "options-reordered": function ($event) {
                return _setup.colors.onColorOptionsReordered($event)
              },
              "preview-selection": function ($event) {
                return _setup.colors.previewColorOption($event)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function () {
                  return [
                    _c(_setup.CInput, {
                      attrs: {
                        value: _setup.outlineWidth,
                        label: "Width",
                        type: "number",
                        min: 0,
                        max: _setup.MAX_OUTLINE_WIDTH,
                        step: "0.1",
                        disabled: _setup.disabled,
                      },
                      on: { input: _setup.updateOutlineWidth },
                    }),
                  ]
                },
                proxy: true,
              },
              {
                key: "actions",
                fn: function () {
                  return [
                    _c(_setup.CButton, {
                      staticClass: "remove-outline-btn",
                      attrs: {
                        variant: "secondary",
                        text: "Remove Outline",
                        icon: ["far", "trash"],
                        disabled: _setup.disabled,
                      },
                      on: { click: _setup.removeOutline },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
          }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }